import React, { useState, useEffect } from "react";
import { putEstacion as modifEstacion } from "../helpers/rutaEstaciones";
import { Modal, Button } from "react-bootstrap";
import "animate.css";

const tiposEstacion = [
  "ESTACION",
  "YPF_RUTA",
  "PROVEEDOR_COMBUSTIBLE",
  "OTRO",
];

const ModalFormEstacion = ({ estacion, handleClose, show }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const initialValues = {
    codest: "",
    estacion: "",
    lugar: "",
    domicilio: "",
    telefono: "",
    cuit: "",
    tipoEstacion: "ESTACION",
    permiteCuentaCorriente: true,
    observaciones: "",
  };

  const [formValues, setFormValues] = useState(initialValues);

  useEffect(() => {
    if (estacion && estacion._id) {
      setFormValues({
        codest: estacion.codest || "",
        estacion: estacion.estacion || "",
        lugar: estacion.lugar || "",
        domicilio: estacion.domicilio || "",
        telefono: estacion.telefono || "",
        cuit: estacion.cuit || "",
        tipoEstacion: estacion.tipoEstacion || "ESTACION",
        permiteCuentaCorriente:
          estacion.permiteCuentaCorriente !== undefined
            ? estacion.permiteCuentaCorriente
            : true,
        observaciones: estacion.observaciones || "",
      });
    }
  }, [estacion]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormValues({
        ...formValues,
        [name]: checked,
      });
      return;
    }

    if (["estacion", "lugar", "domicilio", "observaciones"].includes(name)) {
      setFormValues({
        ...formValues,
        [name]: value.toUpperCase(),
      });
      return;
    }

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await modifEstacion(estacion._id, formValues);
      console.log("✅ Estación actualizada:", resp);

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 1800);
    } catch (error) {
      console.error("❌ Error al actualizar estación:", error);
      alert("Error al actualizar estación / proveedor de combustible");
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg">
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Modificar Estación / Proveedor Combustible</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="form-row">
              <div className="form-group mt-2 col-sm-5">
                <label>Estación / Proveedor</label>
                <input
                  type="text"
                  className="form-control"
                  name="estacion"
                  maxLength="60"
                  required
                  value={formValues.estacion}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-2 col-sm-4">
                <label>Lugar</label>
                <input
                  type="text"
                  className="form-control"
                  name="lugar"
                  maxLength="60"
                  required
                  value={formValues.lugar}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-2 col-sm-3">
                <label>Tipo</label>
                <select
                  className="form-control"
                  name="tipoEstacion"
                  value={formValues.tipoEstacion}
                  onChange={handleChange}
                  required
                >
                  {tiposEstacion.map((tipo) => (
                    <option key={tipo} value={tipo}>
                      {tipo}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group mt-3 col-sm-5">
                <label>Domicilio</label>
                <input
                  type="text"
                  className="form-control"
                  name="domicilio"
                  maxLength="80"
                  value={formValues.domicilio}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-3">
                <label>Teléfono</label>
                <input
                  type="text"
                  className="form-control"
                  name="telefono"
                  maxLength="30"
                  value={formValues.telefono}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-3">
                <label>CUIT</label>
                <input
                  type="text"
                  className="form-control"
                  name="cuit"
                  maxLength="20"
                  value={formValues.cuit}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-4 col-sm-1 d-flex align-items-center">
                <input
                  type="checkbox"
                  name="permiteCuentaCorriente"
                  checked={formValues.permiteCuentaCorriente}
                  onChange={handleChange}
                  style={{ marginRight: "6px" }}
                />
                <label style={{ marginBottom: 0, fontSize: "12px" }}>Cta.</label>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group mt-3 col-sm-12">
                <label>Observaciones</label>
                <textarea
                  className="form-control"
                  name="observaciones"
                  rows="2"
                  maxLength="200"
                  value={formValues.observaciones}
                  onChange={handleChange}
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>

            <Button type="submit" variant="dark">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>✅</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormEstacion;